import { Grid3X3, Table } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

interface ViewToggleProps {
  currentView: 'grid' | 'table'
  onViewChange: (view: 'grid' | 'table') => void
}

export function ViewToggle({ currentView, onViewChange }: ViewToggleProps) {
  return (
    <div className='flex border rounded-lg p-1 bg-muted/50'>
      <Button
        variant={currentView === 'grid' ? 'default' : 'ghost'}
        size='sm'
        onClick={() => onViewChange('grid')}
        className='h-8 px-2'
      >
        <Grid3X3 className='w-4 h-4' />
      </Button>
      <Button
        variant={currentView === 'table' ? 'default' : 'ghost'}
        size='sm'
        onClick={() => onViewChange('table')}
        className='h-8 px-2'
      >
        <Table className='w-4 h-4' />
      </Button>
    </div>
  )
}
